import Box, { BoxProps } from '@mui/material/Box';

export type BoxRowProps = BoxProps;

export const BoxRow = ({ children, sx, ...props }: BoxRowProps) => (
  <Box
    {...props}
    sx={{
      flexWrap: 'wrap',
      ...sx,
      display: 'flex',
      flexDirection: 'row',
    }}
  >
    {children}
  </Box>
);
